import React, { useEffect, useRef, useState } from 'react';
import { Box, Checkbox, Stack, Typography, Skeleton, IconButton } from '@mui/material';

import Hls from 'hls.js';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import styles from './video.module.scss';
import { VideoPlayerProps } from './types';
import { imageMap } from '.images';

const VideoPlayer = ({ link, style }: VideoPlayerProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [videoPath, setVideoPath] = useState<string | undefined>();

  useEffect(() => {
    let hls: Hls;
    if (link) {
      if (typeof link === 'string' && Hls.isSupported()) {
        const video = videoRef.current!;
        hls = new Hls();
        hls.on(Hls.Events.MEDIA_ATTACHED, function () {});
        hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {});
        hls.loadSource(link);
        // bind them together
        hls.attachMedia(video);
        setVideoPath(undefined);
      } else if (link instanceof File) {
        setVideoPath(URL.createObjectURL(link));
      }
    } else {
      setVideoPath(undefined);
    }

    return () => {
      setIsPlaying(false);
      if (hls) {
        hls.destroy();
      }
    };
  }, [link]);

  const togglePlayVideo = () => {
    if (isPlaying) {
      videoRef.current?.pause();
    } else {
      videoRef.current?.play();
    }
    setIsPlaying(!isPlaying);
  };

  const toggleMuteVideo = () => {
    setIsMuted(!isMuted);
  };

  return (
    <Box className={styles.videoWrapper} style={style}>
      {link ? (
        <>
          <Box className={styles.videoAction}>
            <IconButton
              // disableTouchRipple
              // disableRipple
              onClick={() => {
                togglePlayVideo();
              }}
            >
              {isPlaying ? <PauseCircleIcon sx={{ color: 'white' }} /> : <PlayCircleIcon sx={{ color: 'white' }} />}
            </IconButton>
            <IconButton
              // disableTouchRipple
              // disableRipple
              onClick={() => {
                toggleMuteVideo();
              }}
            >
              {isMuted ? <VolumeOffIcon sx={{ color: 'white' }} /> : <VolumeUpIcon sx={{ color: 'white' }} />}
            </IconButton>
          </Box>
          <video
            ref={videoRef}
            // poster={poster}
            className={styles.videoFull}
            // src={data.src}
            // src={localvideolink ? data.src : undefined}
            src={videoPath}
            muted={isMuted}
            autoPlay={false}
            playsInline={true}
            controls={false}
            onEnded={() => {
              setIsPlaying(false);
            }}
            // onClick={() => handleVideoClicked(data)}
          >
            <source src={videoPath} type="video/mp4"></source>
            <source src={videoPath} type="video/mov"></source>
            <source src={videoPath} type="video/webm"></source>
            <source src={videoPath} type="application/x-mpegURL"></source>
          </video>
        </>
      ) : (
        <img src={imageMap['conversion-image']()} />
      )}
    </Box>
  );
};

export default VideoPlayer;
